import { Button, Popover, PopoverContent, PopoverTrigger } from "@heroui/react";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

type FilterPopoverProps = {
  filter: React.ReactNode;
};

export default function FilterPopover({ filter }: FilterPopoverProps) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const hasActiveFilters = useMemo(() => {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    params.delete("pagesize");
    return params.toString().length > 0;
  }, [searchParams]);

  return (
    <Popover placement="bottom" showArrow offset={10}>
      <PopoverTrigger>
        <Button
          color={hasActiveFilters ? "secondary" : "primary"}
          size="sm"
          radius="full"
        >
          {t("actions.search")}
        </Button>
      </PopoverTrigger>
      <PopoverContent>{filter}</PopoverContent>
    </Popover>
  );
}
